module.exports = __webpack_public_path__ + "static/media/product3.e9eae10c.jpg";